import React from "react";
// import DataEngineeringContent from "../function-components/Courses/DataEngineeringContent";
import BackendEngineeringContent from "../function-components/Courses/BackendEngineeringContent";

function BackendEngineering({bannerimg}) {
  return (
    <>
      <BackendEngineeringContent bannerimg={bannerimg}/>
    </>
  );
}

export default BackendEngineering;
